import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  RECRUITMENT_INQUIRY,
  RECRUITMENT_INQUIRY_CREATE,
  RECRUITMENT_INQUIRY_DELETE,
  RECRUITMENT_INQUIRY_LIST,
  RECRUITMENT_INQUIRY_UPDATE_STATUS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const recruitmentInquiryItem = createAsyncThunk(
  RECRUITMENT_INQUIRY,
  async (params: PayloadCreatorParams<`${typeof API.RECRUITMENT_INQUIRY}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.recruitmentInquiryItem(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const recruitmentInquiryCreate = createAsyncThunk(
  RECRUITMENT_INQUIRY_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.RECRUITMENT_INQUIRY}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.recruitmentInquiryCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const recruitmentInquiryItemDelete = createAsyncThunk(
  RECRUITMENT_INQUIRY_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.RECRUITMENT_INQUIRY}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.recruitmentInquiryItemDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const recruitmentInquiryList = createAsyncThunk(
  RECRUITMENT_INQUIRY_LIST,
  async (params: PayloadCreatorParams<`${typeof API.RECRUITMENT_INQUIRY}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.recruitmentInquiryList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const recruitmentInquiryUpdateStatus = createAsyncThunk(
  RECRUITMENT_INQUIRY_UPDATE_STATUS,
  async (
    params: PayloadCreatorParams<`${typeof API.RECRUITMENT_INQUIRY_UPDATE_STATUS}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.recruitmentInquiryUpdateStatus(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const recruitmentInquiryListClear = createAction(`${RECRUITMENT_INQUIRY_LIST}/clear`)
